<template>
    <div class="loading_logo">
        <div class="loading-center">
            <div class="spinner"></div>
            <div class="login_Tips">登录中</div>
        </div>
    </div>
</template>
<script>
    import Oidc from '../common/OidcUtil'
    export default {
        name: 'login',
        created() {
            var that = this;
            Oidc.data().Mgr.getUser().then(function(user) {
				if (user) {
                    localStorage.setItem("accessToken", user.access_token);
                    var url = sessionStorage.getItem("HistoryURL");
                    sessionStorage.removeItem("HistoryURL");
                    if(url && url.indexOf('#/login') == -1){
                        window.location.replace(url);
                    }else{
                        that.$router.push('/');
                    }
                }else{
                    Oidc.data().Mgr.signinRedirect();
                }
			});
        }
	};
</script>